import { render } from "./MainHero.vue?vue&type=template&id=6d17e223&scoped=true"
const script = {}

import "./MainHero.vue?vue&type=style&index=0&id=6d17e223&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d17e223"]])

export default __exports__